(function ($, App, Utils, Components) {
  'use strict';

  var logger = new Logger('CustomSelect');

  Components.create('CustomSelect', {

    Selectors: {
      main: '[data-customselect=true]',
      immediate: '[data-customselect=true][data-customselect-behaviour="immediate"]'
    },

    MainSelector: '.custom-select',

    dataObj: {},

    chain:  function (target, filter, trigger, clearFields) {
      let $target=$("[data-bind-key=" + target + "]");
	    let $availableOptions=$target.find('[data-bind-value]')
          .addClass("hidden")
          .filter('[data-bind-value="' + filter + '"]')
          .removeClass("hidden")
		      .not(':empty');

     /* let targetVal = $target.data('keepValue') === true ? $target.val() : '';

      console.log("Keep Value: ",  $target.data('keepValue'))
      targetVal = $availableOptions.length == 1 ? $availableOptions.first().val() : targetVal;


      $target.val(targetVal).trigger('change');

      $target.attr('data-keep-value', false);
      $target.data("keepValue", false);*/


      let defaultVal = clearFields ? '' : $target.val();
      let targetVal = $availableOptions.length == 1 ? $availableOptions.first().val() : defaultVal;
      $target.val(targetVal).trigger('change');

      if(trigger) {
          $target.trigger({type: trigger, params: {data: {"id": targetVal}}})
      }
    },
    bindEvents: function () {

        // Select chaining - changes bound select options after selection change
        $(Components.CustomSelect.Selectors.main).on('select2:select', function(state){

          if(!state.target.dataset.bindTo) return;
            Components.CustomSelect.chain(state.target.dataset.bindTo, state.params.data.id, state.type, true);
        });

				
        // Select link - automatically redirect after selection change
        $(Components.CustomSelect.Selectors.main).on('change.select2', (e) => {
            let value = e.target.value;

            if (!value) return;
            let $option = $(`option[value="${value}"]`);
            let dataObj = $option.data();

            if (dataObj && 'link' in dataObj) {

                if (dataObj['setStoreCookie']) {
                  Cookies.set('storeId', $option.val());
                  Components.trigger(Components.PreferredStore.Events.storeSaved, {storeId: $option.val()});
                }
                window.location.href = `${dataObj['link']}`;
                return;
            }

            if (value === 'all') {
                $('option[data-select2-id]').prop('disabled', false);
                $(Components.CustomSelect.Selectors.main).each(function () {
                    let data = Utils.jsonDA($(this), 'customselect');
                    $(this).select2('val', data);
                });
            }
        });

        $(Components.CustomSelect.Selectors.immediate).on('change', (e) => {
            $(e.target).closest('form').submit();
        });

      $('.custom-select').not('[data-customselect]').each(function () {
        var $this = $(this), numberOfOptions = $(this).children('option').length;

        $this.addClass('select-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        var $list = $('<ul />', {
          'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
          }).appendTo($list);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function (e) {
          e.stopPropagation();
          $('div.select-styled.active').not(this).each(function () {
            $(this).removeClass('active').next('ul.select-options').hide();
          });
          $(this).toggleClass('active').next('ul.select-options').toggle();
        });


        $listItems.click(function (e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.hide();
          //console.log($this.val());
        });

        $(document).click(function () {
          $styledSelect.removeClass('active');
          $list.hide();
        });

      });

    },

    initSimpleSelect: () => {
	
      $(Components.CustomSelect.Selectors.main).each(function () {
        let data = Utils.jsonDA($(this), 'customselect');
        $(this).select2({
          dropdownParent: $(this).parent(),
          theme: data && data.theme ? `custom__${data.theme}` : 'custom',
            templateResult: (state) => {
                let element = state.element;
                if(element && !$(element).hasClass('hidden'))
                {
                    return $(
                        '<span data-bind-value="' + element.dataset.bindValue + '">' + state.text + '</span>'
                    );
                }
            },
          minimumResultsForSearch: data && data.nosearch ? -1 : 0
        });

        $(this).parent().css('position','relative');

        let target = $(this).data("bind-to");
        let val = $(this).val();
        Components.CustomSelect.chain(target, val);

      });

			Components.CustomSelect.bindEvents();
    },


    init: function () {
      Components.CustomSelect.bindEvents();
      if ($(Components.CustomSelect.Selectors.main).not('[data-customselect=""]').length > 0) {
        if ($(Components.CustomSelect.Selectors.main).data('customselectType') === 'simple') {
          Components.CustomSelect.initSimpleSelect();
        }
      }
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);


